$(document).ready(function () {
    const form = $('.subscribe-block form.main-subscription-registration-form');
    const reactForm = $('.react-subscription-page .subscribe-block form.main-subscription-registration-form')
    if (form.length === 0) return
    if (reactForm.length > 0) return
    const dropDownElement = form.find("select.Country")[0].id;
    if (typeof (dropDownElement) == "undefined") return
    const dropDownElementId = document.getElementById(dropDownElement);
    const ctext = $("#select-country-text").text().trim();
    $(`#${dropDownElement}`).siblings('button').find('span').html(ctext);
    for (var i = 0; i < dropDownElementId.options.length; i++) {
        let p = dropDownElementId.options[i];
        (p.innerHTML == ctext) ? p.setAttribute('selected', 'selected') : p.removeAttribute('selected');
    }
});